export default __webpack_public_path__ + "static/media/circlemail.4736b453.svg";